var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.isBeneficiario
        ? _c(
            "el-row",
            [
              _c(
                "el-row",
                { staticClass: "marginTop", attrs: { span: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-display", {
                        attrs: { label: "Tipo de cadastro:", content: _vm.tipo }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-display", {
                        attrs: {
                          label: "Data de cadastro:",
                          content: this.dataCadastro
                        }
                      })
                    ],
                    1
                  ),
                  _vm.dataRetificacao
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            attrs: {
                              label: "Data de retificação:",
                              content: this.dataRetificacao
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-row",
        [
          _vm.qualificacao && !_vm.isProcessoFisico
            ? _c("app-divider", { attrs: { label: "Qualificação" } })
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "marginTop" },
        [
          _vm.qualificacao && !_vm.isProcessoFisico
            ? _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "div",
                  { staticClass: "margem" },
                  [
                    _c("app-display", {
                      class:
                        _vm.compararQualificacao &&
                        _vm.compararQualificacao.mudouArea
                          ? "text"
                          : "",
                      attrs: {
                        label: _vm.labelQualificacao.area,
                        content:
                          _vm.formatterDecimal(_vm.qualificacao.area) +
                          " hectare(s)"
                      }
                    }),
                    _vm.qualificacao.municipio
                      ? _c("app-display", {
                          class:
                            _vm.compararQualificacao &&
                            _vm.compararQualificacao.mudouMunicipio
                              ? "text"
                              : "",
                          attrs: {
                            label: "Município:",
                            content: _vm.qualificacao.municipio.nome
                          }
                        })
                      : _vm._e(),
                    !_vm.isBahia
                      ? _c("app-display", {
                          class:
                            _vm.compararQualificacao &&
                            _vm.compararQualificacao.mudouRenda
                              ? "text"
                              : "",
                          attrs: {
                            label: "Qual a renda familiar?",
                            content: _vm.renda
                          }
                        })
                      : _vm._e(),
                    _c("app-display", {
                      class:
                        _vm.compararQualificacao &&
                        _vm.compararQualificacao.mudouCargoPublico
                          ? "text"
                          : "",
                      attrs: {
                        label: _vm.labelQualificacao.cargoPublico,
                        content: _vm.qualificacao.cargoPublico ? "Sim" : "Não"
                      }
                    }),
                    _c("app-display", {
                      class:
                        _vm.compararQualificacao &&
                        _vm.compararQualificacao.mudouPossuiImovelRuralTitulado
                          ? "text"
                          : "",
                      attrs: {
                        label: _vm.labelQualificacao.possuiImovelRuralTitulado,
                        content: _vm.qualificacao.possuiImovelRuralTitulado
                          ? "Sim"
                          : "Não"
                      }
                    }),
                    _vm.qualificacao.possuiImovelRuralTitulado
                      ? _c("app-display", {
                          attrs: {
                            label: _vm.labelQualificacao.tamanhoImovelTitulado,
                            content:
                              _vm.formatterDecimal(
                                _vm.qualificacao.tamanhoImovelTitulado
                              ) + " hectare(s)"
                          }
                        })
                      : _vm._e(),
                    _c("app-display", {
                      class:
                        _vm.compararQualificacao &&
                        _vm.compararQualificacao.mudouOcupaImovel
                          ? "text"
                          : "",
                      attrs: {
                        label: _vm.isMunicipioIlha(_vm.cadastroOriginal)
                          ? _vm.labelQualificacao.ocupaImovelIlha
                          : _vm.labelQualificacao.ocupaImovel,
                        content: _vm.qualificacao.ocupaImovel ? "Sim" : "Não"
                      }
                    }),
                    !_vm.isBahia
                      ? _c("app-display", {
                          class:
                            _vm.compararQualificacao &&
                            _vm.compararQualificacao.mudouExploracaoAgricola
                              ? "text"
                              : "",
                          attrs: {
                            label: _vm.labelQualificacao.exploracaoAgricola,
                            content: _vm.qualificacao.exploracaoAgricola
                              ? "Sim"
                              : "Não"
                          }
                        })
                      : _vm._e(),
                    _vm.isBahia
                      ? _c("app-display", {
                          attrs: {
                            label:
                              _vm.labelQualificacao.naturezaGlebaPretendida,
                            content: _vm.qualificacao.situacaoGleba
                              ? "Sim"
                              : "Não"
                          }
                        })
                      : _vm._e(),
                    _vm.cadastroOriginal.tipo === "PEAS"
                      ? _c("app-display", {
                          attrs: {
                            label: "Situação: ",
                            content: _vm.getSituacao
                          }
                        })
                      : _vm._e(),
                    _c(
                      "span",
                      { staticClass: "pessoas" },
                      [
                        _vm._v("Lista de pessoas que acompanham o processo"),
                        _vm._l(_vm.pessoas, function(pessoa, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "viewPersonInfo" },
                            [
                              _c("span", { staticClass: "text" }, [
                                _vm._v(_vm._s(pessoa.nomeRazaoSocial))
                              ]),
                              _c("span", { staticClass: "text" }, [
                                _vm._v(
                                  _vm._s(
                                    pessoa.documento
                                      ? pessoa.documento.nome
                                      : ""
                                  )
                                )
                              ]),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    effect: "dark",
                                    content: "Baixar arquivo",
                                    placement: "top"
                                  }
                                },
                                [
                                  pessoa.documento
                                    ? _c(
                                        "button",
                                        {
                                          staticClass: "buttonDocument",
                                          on: {
                                            click: function($event) {
                                              return _vm.getDownload(
                                                pessoa.documento
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("font-awesome-icon", {
                                            attrs: {
                                              icon: "download",
                                              size: "lg"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ]
                              )
                            ],
                            1
                          )
                        })
                      ],
                      2
                    )
                  ],
                  1
                )
              ])
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4960b384", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4960b384","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/informacoesQualificacao.vue
// module id = null
// module chunks = 